import styled, { keyframes } from 'styled-components';
import { ReactComponent as Spinner } from 'assets/icons/spinner.svg';

const Rotate = keyframes`
    from {
        transform: rotate(0);
    }

    to {
        transform: rotate(360deg);
    }
`;

const Loading = styled(Spinner)`
  color: ${({ theme }) => theme.textSecondary};
  height: ${({ small }) => (small ? '32px' : '64px')};
  width: ${({ small }) => (small ? '32px' : '64px')};
  transform-origin: center center;
  animation: ${Rotate} 2s infinite forwards linear;
`;

export default Loading;
